import React from 'react';
import { OldCloset } from '../components/oldCloset';

export const OldClosetPage: React.FC = () => {
  return <OldCloset />;
};
